// extracted by mini-css-extract-plugin
module.exports = {"MoreLink":"MoreLink-module__MoreLink___2g_Qe"};